export const FILTERS_ARGS = {
  SEARCH: 'search',
  CITY: 'exam_location',
  CITY_COURSE: 'city',
  QUEUE_EXAM_LOCATION: 'queue_exam_location',
  CBR_USER: 'cbr_user',
  CBR_STATUS: 'cbr_status',
  EXAM_PRODUCT: 'product_name',
  FAILED_EXACT: 'failed__exact',
  QUEUE_EXAM_DATE_AFTER: 'queue_exam_date_after',
  QUEUE_EXAM_DATE_BEFORE: 'queue_exam_date_before',
  EXAM_DATE_AFTER: 'exam_date_after',
  EXAM_DATE_BEFORE: 'exam_date_before',
  EXAM_TIME_AFTER: 'exam_time_after',
  EXAM_TIME_BEFORE: 'exam_time_before',
  LABEL: 'labels',
  LABEL_EXCLUDE: 'labels_exclude',
  CANDIDATE_PAGE: 'candidate_page',
  HAS_AVALIABLE_SLOTS: 'has_available_slots',
  EXAM_REQUESTS_COUNT: 'exam_requests_count',
  MAIN_DATE_AFTER: 'main_date_after',
  MAIN_DATE_BEFORE: 'main_date_before',
  CUSTOM_LABELS: 'custom_labels',
  CUSTOM_LABELS_EXCLUDE: 'custom_labels_exclude',
  COURSE_DATE_AFTER: 'course_date_after',
  COURSE_DATE_BEFORE: 'course_date_before',
  QUEUE_EXAM_DATE_EXCLUDE_AFTER: 'queue_exam_date_exclude_after',
  QUEUE_EXAM_DATE_EXCLUDE_BEFORE: 'queue_exam_date_exclude_before',
  QUEUE_EXAM_DATE_STRICT: 'queue_exam_date_strict',
  QUEUE_TIME_BEFORE: 'queue_time_before',
  QUEUE_TIME_AFTER: 'queue_time_after',
  LAST_ERROR: 'last_error'
}

export const CANDIDATE_PAGE = {
  TASKS: 'tasks',
  WAIT: 'wait',
  RESERVE_EXCHANGE: 'reserve_exchange',
  RESERVED_EXCHANGED: 'reserved_exchanged',
  PROCESSED: 'processed',
  RESERVED_ALL: 'all_reserved',
  RESERVED_ALL_WILL_COME: 'all_reserved_will_come',
  RESERVED_ALL_WILL_NOT_COME: 'all_reserved_will_not_come',
  MIJN_CBR_QUEUE: 'mijn_cbr_queue',
  TOP_CBR_QUEUE: 'top_cbr_queue',
  TOB_CBR_EXCHANGE_QUEUE: 'top_cbr_exchange_queue',
  TOB_CBR_RESERVE_QUEUE: 'top_cbr_reserve_queue',
  ALL: 'all',
}

export const SORT_ARGS = {
  IN_QUEUE: 'is_in_queue',
  FAILED: 'failed',
  ON_HOLD: 'is_on_hold',
  ORDERING: 'ordering',
  NAME: 'name',
  BIRTHDAY: 'date_of_birth',
  STATUS: 'cbr_status',
  CBR_ACCOUNT: 'cbr_user',
  PRODUCT_NAME: 'product_name',
  RESERVED_INFO: 'exam_datetime',
  EXAM_LOCATION: 'exam_location',
  COLOR: 'color'
}

export const CBR_STATUS = {
  NEW: 'new',
  SUBMITED: 'submited',
  ACCEPTED: 'accepted',
  RESERVED: 'reserved',
  ARCHIVED: 'archived'
}

export const CBR_STATUS_OPTIONS = [
  CBR_STATUS.NEW,
  CBR_STATUS.SUBMITED,
  CBR_STATUS.ACCEPTED,
  CBR_STATUS.RESERVED,
  CBR_STATUS.ARCHIVED
]

export const FREE_STATUSES = [CBR_STATUS.NEW, CBR_STATUS.ARCHIVED]

export const QUEUE_OPTIONS = [
  {
    value: null,
    label: 'All'
  },
  {
    value: true,
    label: 'Yes'
  },
  {
    value: false,
    label: 'No'
  }
]

export const FAILED_OPTIONS = [
  {
    value: null,
    label: 'All'
  },
  {
    value: true,
    label: 'Yes'
  },
  {
    value: false,
    label: 'No'
  }
]

export const ON_HOLD_OPTIONS = [
  {
    value: null,
    label: 'All'
  },
  {
    value: true,
    label: 'Yes'
  },
  {
    value: false,
    label: 'No'
  }
]

export const DEFAULT_BOOLEAN_OPTIONS = [
  {
    value: null,
    label: 'All'
  },
  {
    value: true,
    label: 'Yes'
  },
  {
    value: false,
    label: 'No'
  }
]

export const LABELS = {
  ON_HOLD: 'is_on_hold',
  NO_DATES: 'no_dates',
  NO_CANDIDATE_NUMBER: 'no_candidate_number',
  RESERVATION_ERROR: 'reservation_error',
  ACCEPTANCE_ERROR: 'acceptance_error',
  EXCHANGE_ERROR: 'exchange_error',
  IN_QUEUE: 'is_in_queue',
  IS_IN_EXCHANGE_QUEUE: 'is_in_exchange_queue',
  NEW_RESERVE: 'new_reserve',
  NEW_EXCHANGE: 'new_exchange',
  IS_MIJN_RESERVATION: 'is_mijn_reservation',
  BAD_EXAM: 'bad_exam'
}

export const SET_MIJN_ARGS = {
  DATETIME: 'datetime',
  LOCATION: 'location',
  PRODUCT_NAME: 'product_name',
  COURSE: "course_id"
}

export const BULK_MIJN = {
  LOCATION: 'location',
  COURSE: "course_id",
  EXAM: 'exam'
}

export const ORIGINS = {
  APPLICATION: 'APPLICATION',
  ADDED_MANUALLY: 'ADDED_MANUALLY',
  CONFIRMED_SUGGESTION: 'CONFIRMED_SUGGESTION',
  QUICK_RESERVE: 'QUICK_RESERVE'
}

export const SUGGEST_EXAM_TEMPLATE = `We zijn druk bezig om op korte termijn een cursus met examen voor jullie te regelen. We begrijpen dat iedereen zo snel mogelijk weer aan de slag wilt en zijn theorie wil halen. Op dit moment zijn er examens beschikbaar gekomen. Voordeel hiervan is dat het plekken op korte termijn betreffen. Er zijn maar een beperkt aantal examens beschikbaar bij het CBR, dus indien je deze data wilt geef het dan zo spoedig mogelijk door. Let op: op = op.`
export const SUGGEST_EXAM_SUBJECT = `Data nu beschikbaar`

export const SUGGEST_MIJN_TEMPLATE = `Er zijn momenteel een beperkt aantal examens vrijgekomen die op dezelfde dag zijn als onze cursussen. Je kunt deze direct reserveren. Het CBR heeft in verband met maatregelen voor Covid-19 een beperkte examen capaciteit. Houd er rekening mee dat ze erg snel opraken. Deze examens zijn beschikbaar via www.mijncbr.nl. Indien deze datum schikt kun je de reservering direct in orde maken. Zijn de examens niet meer beschikbaar of schikt de datum niet, dan laten we je op je voorkeursdagen staan en zullen we je opnieuw berichten als er een nieuwe optie komt. Het CBR geeft nog nieuwe examens vrij, deze kunnen ook op een eerdere datum zijn. Als er examens vrijkomen op een van je voorkeursdagen dan zullen wij deze proberen te reserveren. Let op: reserveer alleen een examen op de datum en tijden die we hieronder hebben aangegeven.`
export const SUGGEST_MIJN_SUBJECT = `CBR-examen enkel via Mijn CBR beschikbaar`


export const API_ATTRIBUTES = {
  number: 'candidateNumber',
  date_of_birth: 'candidateBirthday',
  cbr_user: 'accountUsername',
  cbr_status: 'status',
  reserved_exam: 'reservedExam',
  exam_reservation_requests: 'requests',
  phone: 'candidateTel',
  failed: 'failed',
  was_exchanged: 'wasExchanged',
  notes: 'notes',
  is_wait_list: 'isWaitList',
  last_error: 'lastError',
  is_in_queue: 'inQueue',
  is_in_exchange_queue: 'inExchangeQueue',
  no_dates: 'noDates',
  no_candidate_number: 'noCandidateNumber',
  acceptance_error: 'acceptanceError',
  reservation_error: 'reservationError',
  exchange_error: 'exchangeError',
  new_reserve: 'newReserve',
  new_exchange: 'newExchange',
  product_name: "productName",
  labels: 'labels',
  is_mijn_reservation: "isMijnReservation",
  sent_email: 'sentEmails',
  payments: 'payments',
  email: 'candidateEmail',
  course_id: 'courseDate'
}

export const API_ATTRIBUTES_NESTED = {
  requests: {
    course_exam_id: 'exam',
    location: 'location',
    comment: 'comment',
    course_id: 'courseDate',
    is_on_hold: 'onHold',
    exam_comment: 'examComment'
  },
  
}
